import { render } from "./OrgListView.vue?vue&type=template&id=1ed99589&scoped=true&ts=true"
import script from "./OrgListView.vue?vue&type=script&lang=ts"
export * from "./OrgListView.vue?vue&type=script&lang=ts"

import "./OrgListView.vue?vue&type=style&index=0&id=1ed99589&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ed99589"]])

export default __exports__